import './LoadingScreen.css';

const LETTERS = [
  'M22 20V68 M22 20H42C64 20 64 44 42 44H22 M22 44H44C68 44 68 68 44 68H22',
  'M84 68V20L128 68V20',
  'M148 20L160 68L177 34L194 68L206 20',
];

export default function LoadingScreen({ label = 'Loading page…', fullScreen = true }) {
  return (
    <section className={`bnw-loading ${fullScreen ? 'bnw-loading--full' : ''}`} role="status" aria-label={label} aria-live="polite" aria-busy="true">
      <div className="bnw-loading__art" aria-hidden="true">

        <div className="bnw-loading__core">
          <svg viewBox="0 0 228 88" fill="none" stroke="currentColor" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round">
            {LETTERS.map((path, index) => <path key={`ghost-${index}`} d={path} className="bnw-loading__letter-ghost" />)}
            {LETTERS.map((path, index) => <path key={index} d={path} pathLength="1" className={`bnw-loading__letter bnw-loading__letter--${index}`} />)}
          </svg>
        </div>

      </div>
    </section>
  );
}
